export const isPurchaseUser = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return ["purchase", "accounts"].includes(user?.role?.toLowerCase());
};
